import React from 'react'
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from "./pages/Home";
import About from "./pages/About";
import Visuals from "./pages/Visuals";
import Contact from "./pages/Contact";
import ArticlesList from "./pages/ArticlesList";
import Article from "./pages/Article";
import { createTheme, ThemeProvider } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Borel',
    ].join(','),
  }
})


const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Layout>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />}/>
            <Route path="/visuals" element={<Visuals />}/>
            <Route path="/contact" element={<Contact />}/>
            <Route path="/articles" element={<ArticlesList />}/>
            <Route path="/article/:articleId" element={<Article />}/>
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  )
}

export default App
